import { CreateBelongItemDTO } from './domain/models/BelongItem'
import { BelongRepository } from './domain/repositories/BelongRepository'
import { belongDatasourceAdapter } from './external/belongDatasouceAdapter'
import { belongRepositoryAdapter } from './infra/belongRepositoryAdapter'

export const belongInstance = Belong(
  belongRepositoryAdapter(belongDatasourceAdapter)
)

export function Belong(belongRepository: BelongRepository) {
  return {
    async updateOutgoingSetting() {
      return await belongRepository.updateOutgoingSetting()
    },
    async updateIncomingSetting() {
      return await belongRepository.updateIncomingSetting()
    },
    async updatePreparingSetting() {
      return await belongRepository.updatePreparingSetting()
    },
    async settings() {
      return await belongRepository.settings()
    },
    async listItem() {
      return await belongRepository.listItem()
    },
    async createItem(data: CreateBelongItemDTO) {
      return await belongRepository.createItem(data)
    },
    async deleteItem(itemId: string) {
      return await belongRepository.deleteItem(itemId)
    },

    async getDateBelongReport(patientId: string, date: string) {
      return belongRepository.getDateBelongReport(patientId, date)
    },
    async getWeekBelongReport(patientId: string, date: string) {
      return belongRepository.getWeekBelongReport(patientId, date)
    },
    async getMonthBelongReport(patientId: string, month: string, year: string) {
      return belongRepository.getMonthBelongReport(patientId, month, year)
    },
    async getSemesterBelongReport(
      patientId: string,
      year: string,
      semester: string
    ) {
      return belongRepository.getSemesterBelongReport(patientId, year, semester)
    },
    async getCustomBelongReport(
      patientId: string,
      startDate: string,
      endDate: string
    ) {
      return belongRepository.getCustomBelongReport(
        patientId,
        startDate,
        endDate
      )
    },

    async getPendingList() {
      return await belongRepository.getPendingList()
    },
    async getItemsList(patientId: string) {
      return await belongRepository.getItemsList(patientId)
    },
    async updateStatusItem(itemId: string, status: string) {
      return await belongRepository.updateStatusItem(itemId, status)
    }
  }
}
